import React from 'react';

interface AlignedCellProps {
  value: string;
  width?: string;
  justify?: string;
}

const AlignedCell: React.FC<AlignedCellProps> = ({ value, width, justify }) => {
  return (
    <div 
      style={{ 
        display: 'flex', 
        justifyContent: justify || 'right', 
        alignItems: 'center', 
        height: '100%',
        paddingRight:"28px",

        //backgroundColor:'darkgray',
        width: width || '100%'
      }}
    >
      {value}
    </div>
  );
};

export default AlignedCell;

